export default "__VITE_ASSET__DBykWr7k__"